var _style, _line, _path, _path2, _circle, _polyline, _line2, _path3, _path4, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeBodyLinkedIn = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "NodeBodyLinkedIn",
  x: "0px",
  y: "0px",
  viewBox: "0 0 320 98.3",
  style: {
    enableBackground: "new 0 0 320 98.3"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stlin0{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.stlin1{fill:#071F33;}\r\n\t.stlin2{fill:none;stroke:#50AD70;stroke-width:2;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 234.5,
  y1: 15.5,
  x2: 77.5,
  y2: 15.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M201.3,65.6h-74.3c-4.9,0-8.8-3.9-8.8-8.5V8.5c0-4.7,3.9-8.5,8.8-8.5h74.3c4.9,0,8.8,3.9,8.8,8.5V57 C210,61.7,206.1,65.6,201.3,65.6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M200.5,98.3h-13c-2.2,0-4.2-2-4.2-4.2v-13c0-2.2,2-4.2,4.2-4.2h13c2.4,0,4.2,2,4.2,4.2v13 C204.6,96.5,202.8,98.3,200.5,98.3z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "stlin2",
  cx: 74.6,
  cy: 15.2,
  r: 2.9
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "stlin2",
  points: "187.1,83.6 194.1,90.4 200.9,83.6 "
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 194,
  y1: 81.6,
  x2: 194,
  y2: 62.7
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "stlin0",
  d: "M233.6,15.3c0,0-1.3-5,5.7-6.8h80"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "stlin0",
  d: "M233.6,15.5c0,0-1.3,5,5.7,6.8h80"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 246.8,
  y1: 22.3,
  x2: 246.8,
  y2: 8.5
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 253.5,
  y1: 22.3,
  x2: 253.5,
  y2: 8.5
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 260.1,
  y1: 22.3,
  x2: 260.1,
  y2: 8.5
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 266.9,
  y1: 22.3,
  x2: 266.9,
  y2: 8.5
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 273.5,
  y1: 22.3,
  x2: 273.5,
  y2: 8.5
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 280.3,
  y1: 22.3,
  x2: 280.3,
  y2: 8.5
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 287,
  y1: 22.3,
  x2: 287,
  y2: 8.5
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 293.6,
  y1: 22.3,
  x2: 293.6,
  y2: 8.5
})), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 300.4,
  y1: 22.3,
  x2: 300.4,
  y2: 8.5
})), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 307,
  y1: 22.3,
  x2: 307,
  y2: 8.5
})), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
  className: "stlin0",
  x1: 313.8,
  y1: 22.3,
  x2: 313.8,
  y2: 8.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M12.3,26.3h2.2v15.8h8.7V44h-11V26.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M33.4,32.7h-6.1v-1.8h8.3V44h-2.2V32.7z M32.5,26.4c0-1,0.8-1.7,1.8-1.7s1.8,0.7,1.8,1.7 c0,1.1-0.8,1.7-1.8,1.7S32.5,27.5,32.5,26.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M43.6,30.9h1.8l0.2,2.2h0.1c1.4-1.4,2.9-2.5,4.9-2.5c3.1,0,4.5,1.8,4.5,5.3V44h-2.2v-7.9c0-2.5-0.9-3.6-3-3.6 c-1.6,0-2.6,0.8-4.1,2.3V44h-2.2V30.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M60.1,24.8h2.2v13h0.1l7-6.9H72l-9.7,9.6V44h-2.2V24.8z M65.1,37l1.3-1.5l6.3,8.4h-2.5L65.1,37z"
}), /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M75.3,37.4c0-4.3,3.2-6.9,6.7-6.9c3.8,0,6,2.5,6,6.2c0,0.5-0.1,1-0.1,1.3H76.8v-1.7h9.8L86,37 c0-3.1-1.5-4.6-3.9-4.6c-2.4,0-4.5,1.8-4.5,5.1c0,3.4,2.2,5.1,5.1,5.1c1.6,0,2.8-0.5,4-1.2l0.8,1.5c-1.3,0.9-3,1.6-5.1,1.6 C78.4,44.3,75.3,41.8,75.3,37.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "stlin1",
  d: "M91.3,37.5c0-4.3,2.8-6.9,5.9-6.9c1.6,0,2.8,0.6,3.9,1.7h0.1l-0.1-2.4v-5h2.2V44h-1.8l-0.2-1.7h-0.1 c-1.1,1.1-2.6,2.1-4.3,2.1C93.5,44.3,91.3,41.8,91.3,37.5z M101.1,40.5V34c-1.2-1.1-2.3-1.5-3.4-1.5c-2.3,0-4.1,2-4.1,5 c0,3.1,1.5,5,3.9,5C98.7,42.4,99.9,41.8,101.1,40.5z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeBodyLinkedIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeBodyLinkedIn.80d9ec20.svg";
export { ForwardRef as ReactComponent };